/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/dashboard'
const prefixCalendar = 'cam/calendard'

export const GET_STAT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_STAT_SUCCESS'
)
export const CLEANER_STAT = ReduxHelpers.Types.createActionType(
  prefix,
  'CLEANER_STAT'
)
export const SEARCH_RESULTS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'SEARCH_RESULTS_SUCCESS'
)
export const SEARCH_USAGE_RESULTS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'SEARCH_USAGE_RESULTS_SUCCESS'
)
export const SEARCH_CROSS_ACCOUNT_RESULTS_SUCCESS =
  ReduxHelpers.Types.createActionType(
    prefix,
    'SEARCH_CROSS_ACCOUNT_RESULTS_SUCCESS'
  )
export const SEARCH_PRIVILEGE_RESULTS_SUCCESS =
  ReduxHelpers.Types.createActionType(
    prefix,
    'SEARCH_PRIVILEGE_RESULTS_SUCCESS'
  )
export const REFRESH_CALENDAR_SUCCESS = ReduxHelpers.Types.createActionType(
  prefixCalendar,
  'REFRESH_CALENDAR_SUCCESS'
)
export const REFRESH_CALENDAR_FAIL = ReduxHelpers.Types.createActionType(
  prefixCalendar,
  'REFRESH_CALENDAR_FAIL'
)
export const SERVER_ERRORS = ReduxHelpers.Types.createActionType(
  prefix,
  'SERVER_ERRORS'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const REQUEST_PENDING_GRAPH = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING_GRAPH'
)
export const GET_SEV_COUNTS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_SEV_COUNTS'
)
export const GET_STATS_DATA = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_STATS_DATA'
)
